// Generic imports
import React from "react"
import styled from "styled-components"

// Other components imports

// Redux imports

// Static imports

// Utils imports

const Styles = styled.div`
  display: inline-block;
  width: 100%;

  label {
    color: #51b848;
  }

  select {
    width: 100%;
    background: #ffffff;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    background: #ffffff;
    border: 1px solid #a0a4a8;
    box-sizing: border-box;
    border-radius: 8px;
  }
`

export default function Select(props) {
  const { label, id, children, ...otherProps } = props
  const inputId = id !== null ? id : props.name
  // const inputId = id

  return (
    <Styles className="taman-select">
      {label ? <label htmlFor={inputId}>{label}</label> : <></>}
      <select id={inputId} {...otherProps}>
        {children}
      </select>
    </Styles>
  )
}
